/************************************************************************************

* CUSTOMIZE FUNCTION: Customize add-on price

*************************************************************************************/


// =====================
// Event/Utility Functions
// =====================

function l_debounce(fn, wait) {
	let t

	return (...args) => {
		clearTimeout(t)
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

// =====================
// Money Formatting
// =====================

function l_parseMoneyToCents(value, format = '') {
	if (!value) return 0

	const formatString = format || theme.settings.moneyFormat

	if (!formatString) return 0

	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
	const placeholder = formatString.match(placeholderRegex)?.[1]

	let decimalSeparator = '.'
	let thousandSeparator = ','

	// Determine separators based on Shopify placeholder
	switch (placeholder) {
		case 'amount':
			decimalSeparator = '.'
			thousandSeparator = ','
			break

		case 'amount_no_decimals':
			decimalSeparator = ''
			thousandSeparator = ','
			break

		case 'amount_with_comma_separator':
			decimalSeparator = ','
			thousandSeparator = '.'
			break

		case 'amount_no_decimals_with_comma_separator':
			decimalSeparator = ''
			thousandSeparator = '.'
			break
	}

	// Remove currency symbols and non-numeric characters
	let numericValue = String(value)
		.replace(/[^0-9.,\s]/g, '')
		.trim()

	// Remove thousand separators
	if (thousandSeparator) {
		const regex = new RegExp('\\' + thousandSeparator, 'g')
		numericValue = numericValue.replace(regex, '')
	}

	// Normalize decimal separator to dot
	if (decimalSeparator && decimalSeparator !== '.') {
		numericValue = numericValue.replace(decimalSeparator, '.')
	}

	const amount = parseFloat(numericValue)

	if (isNaN(amount)) return 0

	return Math.round(amount * 100)
}

function l_formatMoney(cents, format = '') {
	let value = ''
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
	const formatString = format || theme.settings.moneyFormat|| '${{amount}}'

	if (typeof cents == 'string') {
		cents = cents.replace('.', '')
	}

	function defaultOption(opt, def) {
		return typeof opt == 'undefined' ? def : opt
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2)
		thousands = defaultOption(thousands, ',')
		decimal = defaultOption(decimal, '.')

		if (isNaN(number) || number == null) {
			return 0
		}

		number = (number / 100.0).toFixed(precision)

		var parts = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents = parts[1] ? decimal + parts[1] : ''

		return dollars + cents
	}

	switch (formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2)
			break
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0, ' ', '.')
			break
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',')
			break
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', '.')
			break
	}

	return formatString.replace(placeholderRegex, value)
}

document.addEventListener('DOMContentLoaded', () => {
  const productBlocksEl = document.querySelector('.product-single__meta')
  if (!productBlocksEl) return;

  function l_infiniteOptionUpdatePrices() {
    // Helper to query element and optionally throw for missing element
    const getEl = (selector) => document.querySelector(selector);

    const infiniteoptionsPriceContainerEl = getEl('.infiniteoptions-price');
    const infiniteoptionsPriceEl = infiniteoptionsPriceContainerEl.querySelector('.price-item.price-item--regular');
    const currentVariantPriceEl = getEl('.product-block.product-block--price');

    console.log(infiniteoptionsPriceContainerEl);
    console.log(infiniteoptionsPriceEl);
    console.log(currentVariantPriceEl);

    if (!infiniteoptionsPriceEl || !currentVariantPriceEl) return;

    infiniteoptionsPriceContainerEl.classList.add('l-hidden')

    // Parse prices
    const infiniteoptionsPrice = l_parseMoneyToCents(infiniteoptionsPriceEl.textContent.trim());
    const currentVariantPrice = l_parseMoneyToCents(currentVariantPriceEl.textContent);

    // Compute add-on price
    const addOnPrice = infiniteoptionsPrice - currentVariantPrice;

    // Query all price elements together
    const priceEls = {
      plus: document.getElementById('productPricePlus'),
      addOn: document.getElementById('productPriceAddOn'),
      equal: document.getElementById('productPriceEqual'),
      total: document.getElementById('productPriceTotal')
    };

    // Remove hidden class and update content for available elements
    Object.values(priceEls).forEach(el => {
      if (el) el.classList.remove('l-hidden');
    });

    if (priceEls.addOn) {
      priceEls.addOn.textContent = l_formatMoney(addOnPrice);
    }
    if (priceEls.total) {
      priceEls.total.textContent = infiniteoptionsPriceEl.textContent.trim();
    }
  }

  productBlocksEl.addEventListener('change', () => {
    const delayTimes = [1500, 2000];

    delayTimes.forEach(delay => {
      l_debounce(() => {
        l_infiniteOptionUpdatePrices();
      }, delay)();
    });
  });

  document.addEventListener('variant:change', function (event) {
    const delayTimes = [1500, 2000];

    delayTimes.forEach(delay => {
      l_debounce(() => {
        l_infiniteOptionUpdatePrices();
      }, delay)();
    });
  });

})

